import React, { useEffect, useRef, useState } from "react";

const MultiSelectDropdown = ({ options, placeholder, onChange }) => {
    const [willOpenOption, setWillOpenOption] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const optionsRef = useRef();

    function optionHandleClickOutside(event) {
        if (optionsRef.current && !optionsRef.current.contains(event.target)) {
            setWillOpenOption(false);
        }
    }
    const toggleWillOpenOption = () => {
        setWillOpenOption(!willOpenOption);
    };

    const isAlreadySelected = (selectedOption) => {
        return selectedOptions.find(option => selectedOption.value === option.value);
    };

    const onClickOption = (e, selectedOption) => {
        e.stopPropagation();

        let tempSelectedOptions = [];
        if (isAlreadySelected(selectedOption)) {
            tempSelectedOptions = selectedOptions.filter((item) => item.value !== selectedOption.value);
        } else {
            tempSelectedOptions = [...selectedOptions, selectedOption];
        }
        setSelectedOptions(tempSelectedOptions);
        onChange && onChange(tempSelectedOptions);
    };

    useEffect(() => {
        document.addEventListener('mousedown', optionHandleClickOutside);

        return () => {
            document.removeEventListener('mousedown', optionHandleClickOutside);
        };
    }, [optionsRef]);

    const getSummaryText = () => {
        if (selectedOptions.length === 0) return placeholder === "Body Region" ? "All" : placeholder;
        if (selectedOptions.length === 1) return selectedOptions[0].label;
        if (selectedOptions.length === 2) return `${selectedOptions[0].label}, ${selectedOptions[1].label}`;
        return `${selectedOptions.length} Selected`;
    };

    return (
        <div className="position-relative" ref={optionsRef}>
            <div className="select-option filter_width_height kt-space-between" onClick={toggleWillOpenOption}>
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'var(--my-assessments-detail-color)' }}>
                    {getSummaryText()}
                </span>
                <div className="separator">
                    <i className={`fa-solid ${willOpenOption ? 'fa-angle-up' : 'fa-angle-down'}`}></i>
                </div>
            </div>

            {willOpenOption && options && options.length > 0 &&
                <div className="d-flex justify-content-center" style={{color:"#0075B6"}}>
                    <div className="content" >
                        <ul className="options">
                            {options.map((option) => {
                                const isSelected = isAlreadySelected(option);
                                return (
                                    <li
                                        onClick={(e) => onClickOption(e, option)}
                                        key={option.value}
                                        style={{ 
                                            display: 'flex', 
                                            justifyContent: 'space-between', 
                                            alignItems: 'center',
                                            backgroundColor: isSelected ? '#f2f2f2' : 'transparent',
                                            fontWeight: isSelected ? '600' : '400'
                                        }}
                                    >
                                        <span>{option.label}</span>
                                        {isSelected && <i className="fa-solid fa-check" style={{ color: '#0075B6', fontSize: '14px' }}></i>}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            }
        </div>
    );
};

export default MultiSelectDropdown;
